<template>
  <form>
    <div v-if="isWaitlisted" class="text-body text-muted text-center mb-4 fs-6" data-test="waitlisted-text">
      You're on the waitlist for this event. The event organizers may contact you if a spot opens up.
    </div>
    <div v-else-if="existingRegistrationId && isLoggedIn && !hasCompleteRegistration" class="text-body text-muted text-center mb-4 fs-6" data-test="in-progress-text">
      You have a registration in progress.
    </div>
    <div v-else-if="showWaitlistOnly" class="text-body text-muted text-center mb-4 fs-6" data-test="waitlist-available-text">
      This event is at capacity. Join the waitlist and the event organizers may contact you if a spot opens up.
    </div>
    <div v-else-if="isRegistrationFull && !existingRegistrationId" class="text-body text-muted text-center mb-4 fs-6" data-test="registration-full-text">
      This event is full.
    </div>
    <button
      type="button"
      class="btn btn-primary w-100"
      data-test="register-btn"
      :disabled="isRegistrationFull && !isWaitlistAvailable && !existingRegistrationId"
      @click.prevent="submitForm"
    >
      {{ callToActionText }}
    </button>
  </form>
</template>

<script>
import {mapState} from 'vuex';
import {replacePlaceholderWithId, parseFormErrorsGeneric} from '@canopyllc/roots/utils/api.js';

export default {
  name: 'PublicEventDetailApp',
  inject: ['urls', 'api'],
  props: {
    isLoggedIn: {
      type: Boolean,
    },
    registrationTypes: {
      type: Array,
      default: () => [],
    },
    existingRegistrationId: {
      type: Number,
      required: false,
      default: null,
    },
    hasCompleteRegistration: {
      type: Boolean,
      required: false,
      default: false,
    },
    eventId: {
      type: Number,
      required: true,
    },
    isRegistrationFull: {
      type: Boolean,
      required: false,
      default: false,
    },
    isRegistrationOpen: {
      type: Boolean,
      required: false,
      default: true,
    },
    isWaitlistAvailable: {
      type: Boolean,
      required: false,
      default: false,
    },
    isWaitlisted: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      nonFieldErrors: [],
      formFieldErrors: {},
    };
  },
  computed: {
    ...mapState({
      form: (state) => state.app.form,
    }),
    callToActionText() {
      if (this.isWaitlisted) {
        return 'View Waitlist Status';
      }
      if (this.hasCompleteRegistration) {
        return 'View Registration';
      }
      if (this.showWaitlistOnly) {
        return 'Join the Waitlist';
      }
      return 'Register Now';
    },
    showWaitlistOnly() {
      // Direct registration is closed but the screener still offers the waitlist
      return !this.isRegistrationOpen && this.isWaitlistAvailable && !this.existingRegistrationId;
    },
  },
  methods: {
    async submitForm() {
      try {
        if (this.isWaitlisted) {
          // The registration flow 403s for waitlisted rows — the status page is their only page
          window.location.href = this.urls.waitlistConfirmationUrl;
        } else if (this.hasCompleteRegistration) {
          window.location.href = this.urls.confirmationUrl;
        } else if (this.existingRegistrationId) {
          window.location.href = replacePlaceholderWithId(this.urls.invoiceUrl, this.existingRegistrationId);
        } else {
          window.location.href = this.urls.screenerUrl;
        }
      } catch (error) {
        const {formFieldErrors, formAlertMessages} = parseFormErrorsGeneric(error);
        this.nonFieldErrors = formAlertMessages;
        this.formFieldErrors = formFieldErrors;
      }
    },
  },
};
</script>
